import type { Guide } from '../types';

/**
 * S-25.10-05 — anulowanie zlecenia przez CS i Administrację (scenariusz e2e 33). Rekordy z danych pokazowych:
 * DEMO/2026/10/AN1 (gotowe do planowania — okno anulowania, nagrywarka niczego nie zapisuje), AN2 (anulowane,
 * czeka na usunięcie w TMS), AN3 (usunięte w TMS, a import zgłosił rozbieżność).
 */
export const guide: Guide = {
  flagKey: 'intakeOrderCancellation',
  title: 'Anulowanie zlecenia przez CS i Administrację',
  whatItDoes:
    'CS i Administracja anulują zlecenie na karcie zlecenia albo prezlecenia — z powodem, który trafia do historii. Zlecenie przechodzi do stanu „Nieaktualne”, obsadzony pojazd i warianty są zwalniane, oferty na giełdach schodzą same, a działy FTL i Trade dostają powiadomienie. Do TMS nic nie wysyłamy: karta pokazuje „Anulowane w aplikacji — do usunięcia w TMS”, a po usunięciu zlecenia w TMS operator oznacza „Usunięte w TMS”. Gdy TMS dalej podaje zlecenie, import pokazuje rozbieżność.',
  audience: ['CS', 'Administracja', 'administrator'],
  presentationItems: ['S-25.10-05'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'dowolne zlecenie przed realizacją, np. w stanie „Gotowe do planowania”',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide' },
      },
      target: 'intake-cancel-button',
      title: 'Przycisk „Anuluj zlecenie”',
      description:
        'Na karcie zlecenia (i prezlecenia) CS oraz Administracja widzą „Anuluj zlecenie”. Planista i trader go nie mają — decyzję o anulowaniu zapisuje przyjęcie zleceń.',
      action: 'Otwórz kartę zlecenia i kliknij „Anuluj zlecenie”.',
      recorder: { account: 'cs', demo: { kind: 'order', number: 'DEMO/2026/10/AN1' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'dowolne zlecenie przed realizacją',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide' },
      },
      target: 'intake-cancel-reason',
      title: 'Powód i skutki anulowania',
      description:
        'Okno mówi, co się stanie: stan „Nieaktualne”, zwolnienie pojazdu i wariantów, zdjęcie ofert z giełd, powiadomienie FTL i Trade. Powód jest obowiązkowy (co najmniej 10 znaków). Do TMS nic nie idzie.',
      action: 'Wpisz powód, np. „Klient odwołał transport mailem”, i kliknij „Anuluj zlecenie”.',
      recorder: {
        account: 'cs',
        demo: { kind: 'order', number: 'DEMO/2026/10/AN1' },
        actions: [
          { kind: 'click', target: 'intake-cancel-button' },
          { kind: 'fill', target: 'intake-cancel-reason', value: 'Klient odwołał transport mailem' },
        ],
      },
    },
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'zlecenie anulowane w aplikacji (stan „Nieaktualne”)',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide', planningStatus: 'inactive' },
      },
      target: 'intake-cancellation-state',
      title: 'Anulowane w aplikacji — do usunięcia w TMS',
      description:
        'Karta pokazuje, kto i kiedy anulował zlecenie i z jakiego powodu. Zlecenie w TMS usuwa człowiek; potem kliknięciem „Usunięte w TMS” zapisuje oświadczenie w historii.',
      action: 'Usuń zlecenie w TMS, a potem kliknij „Usunięte w TMS” na karcie.',
      recorder: { account: 'adm', demo: { kind: 'order', number: 'DEMO/2026/10/AN2' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'zlecenie anulowane w aplikacji i oznaczone „usunięte w TMS”',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide', planningStatus: 'inactive' },
      },
      target: 'intake-cancellation-tms-still-active',
      title: 'Rozbieżność z TMS',
      description:
        'Jeśli po oznaczeniu „usunięte w TMS” import nadal widzi to zlecenie w TMS, karta pokazuje rozbieżność, a raport importu ją wylicza. Nic się nie cofa — trzeba sprawdzić zlecenie w TMS.',
      action: 'Sprawdź zlecenie w TMS i usuń je, jeśli nadal tam jest.',
      recorder: { account: 'cs', demo: { kind: 'order', number: 'DEMO/2026/10/AN3' } },
    },
  ],
};
